export const PUT_PENDING_USERS = 'verification/PUT_PENDING_USERS';
export const REMOVE_PENDING_USER = 'verification/REMOVE_PENDING_USER';
export const SET_VERIFICATION_SEARCH = 'verification/SET_VERIFICATION_SEARCH';
